import * as constants from './settings-constants';
import { fromJS, Map as iMap, OrderedMap as iOrderedMap } from 'immutable';

const createEmptyTempUser = (currentUserRole) => {
  let userRole = '';

  if (currentUserRole && currentUserRole.toString().indexOf('supplier') > -1) {
    userRole = 'supplier admin';
  } else if (currentUserRole && currentUserRole.toString().indexOf('contractor') > -1) {
    userRole = 'contractor admin';
  }

  return iMap({
    first_name: '',
    last_name: '',
    role: userRole,
    email: '',
  });
};

const initialState = fromJS({
  oldPassword: '',
  newPassword: '',
  confNewPassword: '',
  passResetMessage: {},
  connectionNotificationsEnabled: false,
  currentUserRole: '',
  currentUserEmail: '',
  secondaryEmails: [],
  secondaryEmailsInfo: undefined,
  usersArray: [],
  isHydratedFromServer: false,
  tempUsers: iOrderedMap({
    [0]: createEmptyTempUser(),
  }),
  addUserMessage: {},
  editUserMessage: {},
  userBeingEdited: {},
  emailLinkProcessed: {},
  manageUsersMessage: undefined,
  allActiveUsers: [],
});

export function settings(state = initialState, action) {
  switch (action.type) {
    case constants.UPDATE_SETTINGS_PROP:
      return state.merge(fromJS(action.payload));
    case 'PASSWORD_INPUT_MODIFIED':
      return state.merge(iMap(action.payload));
    case 'RESET_PASSWORD':
      if (!action.payload.error) return state.merge(iMap({ oldPassword: '', newPassword: '', confNewPassword: '', passResetMessage: action.payload }));
      return state.set('passResetMessage', action.payload);
    case 'TOGGLE_CONNECTION_NOTIFICATIONS':
      return state.merge(iMap({ connectionNotificationsEnabled: JSON.parse(action.payload) }));
    case 'HYDRATE_FROM_SERVER':
      return state.merge(iMap({
        isHydratedFromServer: true,
        connectionNotificationsEnabled: action.payload.connectionNotificationsEnabled,
        currentUserRole: action.payload.currentUserRole,
        currentUserEmail: action.payload.currentUserEmail,
        allActiveUsers: action.payload.allActiveUsers,
        usersArray: action.payload.usersArray,
        secondaryEmails: action.payload.secondaryEmails,
        tempUsers: state.get('tempUsers').merge(iOrderedMap({
          [0]: createEmptyTempUser(action.payload.currentUserRole),
        })),
      }));
    case 'ADDED_USER':
      if (action.payload.usersArray) return state.merge(iMap({ usersArray: action.payload.usersArray }));
      return state;
    case constants.START_ADDING_NEW_USER:
      return state.set('addingNewUser', true);
    case 'ADD_TEMP_USER':
      return state.merge(iMap({
        tempUsers: state.get('tempUsers').merge(iOrderedMap({
          [state.get('tempUsers').size.toString()]: createEmptyTempUser(state.get('currentUserRole')),
        })),
      }));

    case 'DELETE_TEMP_USER':
      return state.merge(iMap({
        tempUsers: state.get('tempUsers').delete(action.payload),
      }));

    case 'TEMP_USER_PROP_MODIFIED':
      return state.merge(iMap({
        tempUsers: state.get('tempUsers').merge(iOrderedMap({
          [action.payload.key]: state.get('tempUsers').get(action.payload.key).merge(iMap({
            [action.payload.propName]: action.payload.newValue,
          })),
        })),
      }));

    case 'ADD_NEW_USERS':
      if (action.payload.emailExists === true) {
        return state.merge(iMap({
          // usersArray: action.payload.usersArray,
          addingNewUser: false,
          addUserMessage: {
            emailExists: action.payload.emailExists,
            message: action.payload.message,
          },
        }));
      }

      return state.merge(iMap({
        addingNewUser: false,
        usersArray: action.payload.usersArray,
        tempUsers: iOrderedMap({
          [0]: createEmptyTempUser(state.get('currentUserRole')),
        }),
        addUserMessage: {
          emailExists: action.payload.emailExists,
          message: action.payload.message,
        },
      }));

    case 'CLEAR_TEMP_USERS':
      return state.merge(iMap({
        tempUsers: iOrderedMap({
          [0]: createEmptyTempUser(state.get('currentUserRole')),
        }),
        addUserMessage: {},
      }));

    case 'CLEAR_ADD_USER_MESSAGE':
      return state.merge(iMap({
        addUserMessage: {},
      }));
    case 'CLEAR_EDIT_USER_MESSAGE':
      return state.merge(iMap({
        editUserMessage: {},
      }));
    case 'USER_APPROVED_OR_REJECTED':
    case 'USER_DISABLED':
    case 'USER_DELETED':
      return state.merge(iMap({
        usersArray: action.payload,
      }));

    case 'EDIT_USER_UPDATED':
      return state.merge(iMap({
        userBeingEdited: action.payload,
      }));

    case 'EDIT_USER_PROP_MODIFIED':
      return state.merge(iMap({
        userBeingEdited: fromJS(state.get('userBeingEdited')).merge(iMap(action.payload)).toJS(),
      }));

    case 'EDIT_USER_SAVED':
      if (action.payload.emailExists === true) {
        return state.merge(iMap({
          editUserMessage: {
            emailExists: action.payload.emailExists,
            message: action.payload.message,
          },
        }));
      }
      return state.merge(iMap({
        usersArray: action.payload.usersArray,
        currentUserEmail: action.payload.currentUserEmail,
        editUserMessage: {
          emailExists: action.payload.emailExists,
          message: action.payload.message,
        },
      }));
    case 'CONFIRM_SECONDARY_EMAIL':
    case 'CONFIRMED_DISASSOCIATE_SECONDARY_EMAIL':
    case 'ADD_SECONDARY_EMAIL':
      if (action.payload.secondaryEmails) {
        return state.set('secondaryEmails', action.payload.secondaryEmails)
                    .set('secondaryEmailsInfo', iMap({ error: action.payload.error,
                          emailExists: action.payload.emailExists,
                          message: action.payload.message,
                        }));
      }
      return state.set('secondaryEmailsInfo', iMap({ error: action.payload.error,
                        emailExists: action.payload.emailExists,
                        message: action.payload.message,
                      }));
    case 'RESEND_CONFIRMATION_SECONDARY_EMAIL':
      return state.set('secondaryEmailsInfo', iMap({ error: action.payload.error,
                        emailExists: action.payload.emailExists,
                        message: action.payload.message }));
    case 'RESEND_CONFIRMATION_LINK_USER_SETTINGS':
      return state.set('manageUsersMessage', `Email sent to ${action.payload}`);
    case 'CLEAR_MANAGE_USERS_MESSAGE':
      return state.set('manageUsersMessage', undefined);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/settings/settings-reducer.js